import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { CabinetComponent } from './cabinet/cabinet.component';
import { JurComponent } from './jur.component';
import { MainComponent } from './main/main.component'; 

import { PaymentComponent } from './payment/payment.component';
import { ReestrComponent } from './reestr/reestr.component';
import { PayWithQrComponent } from './payment-kaspi/payment-kaspi.component';

import { PaystoriesComponent } from './paystories/paystories.component';
import { EmployeeComponent } from './employee/employee.component';
import { AppealComponent } from './appeal/appeal.component';  
import { CallbackComponent } from './callback/callback.component';  
import { AuthGuardService } from '../@core/utils/auth-guard-service.service';
import { NotFoundComponent } from './not-found/not-found.component';
const routes: Routes = [{
  path: '',
  component: JurComponent,
  children: [
    {
    path: 'login',
    component: LoginComponent 
  },
{
  // canActivate: [AuthGuardService]
  path: 'cabinet',
  component: CabinetComponent, canActivate: [AuthGuardService]
},
{
  path: 'main', component:MainComponent, canActivate: [AuthGuardService]
},
{
  path: 'payment',
  component: PaymentComponent, canActivate: [AuthGuardService]
},

{
  path: 'paystories',
  component: PaystoriesComponent, canActivate: [AuthGuardService]
},
{
  path: 'employee',
  component: EmployeeComponent, canActivate: [AuthGuardService]
},
{
  path: 'appeal',
  component: AppealComponent, canActivate: [AuthGuardService]
},
{
  path: 'callback',
  component: CallbackComponent, canActivate: [AuthGuardService]
},
{
  path: 'payment-kaspi',
  component: PayWithQrComponent, canActivate: [AuthGuardService]
},

{
  path: '',
  redirectTo: 'cabinet',
  pathMatch: 'full',
  },
{
  path: '**',
  component: NotFoundComponent,

},
],
  
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JurRoutingModule { }

export const routedComponents = [
  JurComponent,
  LoginComponent,
  CabinetComponent,
  PayWithQrComponent
];
